import React, { useState, useEffect } from "react";
import { Paper, Box, Grid, TextField, Button } from "@mui/material";
import BarraTitulo from "../Generico/BarraTitulo";
import AuthService from "../../AuthService";
import { useSnackbar } from "notistack";

const MensagemDelivery = () => {
  const [empresa, setEmpresa] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    getEmpresa();
  }, []);

  const getEmpresa = () => {
    const service = new AuthService();
    const id = JSON.parse(localStorage.getItem("_profile")).empresa.id;

    service
      .get(`/empresa/${id}`)
      .then((empresa) => {
        setEmpresa(empresa);
      })
      .catch((err) => {
        console.error("falha ao buscar empresa: " + err);
      });
  };

  const handleChange = (e) => {
    const updatedEmpresa = { ...empresa, descricaoDelivery: e.target.value };
    setEmpresa(updatedEmpresa);
  };

  const handleSave = () => {
    const service = new AuthService();

    const jsonObj = {
      id: empresa.id,
      descricaoDelivery: empresa.descricaoDelivery?.replace("script>", ""),
    };

    service
      .put("/empresa/changeOnly", jsonObj)
      .then(() => {
        enqueueSnackbar("Mensagem salva com sucesso", { variant: "success" });
      })
      .catch((err) => {
        enqueueSnackbar(`Erro ao salvar a mensagem: ${err}`, {
          variant: "error",
        });
      });
  };

  return (
    <React.Fragment>
      <BarraTitulo title="Mensagem do app" />
      <Paper>
        <Box p={3}>
          <Grid container spacing={2} alignItems="center">
            <Grid
              size={{
                xs: 12,
                sm: 10,
              }}
            >
              <TextField
                variant="outlined"
                label="Mensagem"
                placeholder="Mensagem mostrada para pedidos do delivery na tela principal do cardápio"
                onChange={handleChange}
                value={empresa.descricaoDelivery || ""}
                fullWidth
              />
            </Grid>

            <Grid
              size={{
                xs: 12,
                sm: 2,
              }}
            >
              <Button
                fullWidth
                color="secondary"
                onClick={handleSave}
                variant="contained"
                sx={{ height: "3.5rem" }}
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </React.Fragment>
  );
};

export default MensagemDelivery;
